// Spanish
export default {
    homeScreen : {
        startConversation: 'Iniciar una conversación',
        newConversationButton: 'CONSIGUE AYUDA',
        newMessageButton: '+ Nuevo mensaje',
        allTopics: 'Todos los temas',
        allChatsButton: 'Ver todo',
        poweredBy: 'Powered by Richpanel',
        reOpenConversation: 'Reabrir conversación',
        recentConversations: 'Conversaciones recientes',
        startAChat: 'Iniciar una conversación',
        noRecentConversations: 'No hay conversaciones recientes.',
        noRecentOrders: 'No hay pedidos recientes.',
        haveAQuestion: "¿Tienes alguna pregunta o simplemente quieres saludar? Queremos escucharte.",
        conversationClosed: `Esta conversación ha sido cerrada. Si tienes alguna otra consulta, vuelve a abrir esta conversación.`,
        retry: 'Procesar de nuevo',
        errorOccured: 'Se produjo un error al procesar su solicitud.',
        successMessage: 'Hemos recibido su petición. Nuestro equipo se pondrá en contacto con usted pronto en su correo electrónico.',
        loadingMessage: 'Por favor espera. Estamos enviando su solicitud.',
        goHome: 'VETE A CASA',
        sendUsMessage: 'Mandanos un mensaje',
        endChat: "CHAT FINALIZADO",
        goto: 'Ir',
    },
    orderStatuses: {
        'completed': 'Completo',
        'pending': 'Completo',
        'on hold': 'En Espera',
        'processing': 'Procesando',
        'cancelled': 'Cancelado',
        'fulfilled': 'Cumplida',
        'confirmed': 'Confirmado',
    },

    loginScreen: {
        title: 'Inicia sesión en el centro de ayuda',
        titleForOrdersScreenForward: 'Inicia sesión para ver tus pedidos',
        userIdFieldTitle: "Introduce tu correo electrónico o tu teléfono",
        userIdFieldPlaceHolder: "Introduce tu EMAIL o teléfono",
        sendCode: "ENTRAR",
        enterCode: 'Introduce el código que te hemos enviado',
        enterTheCode: 'Introduce el código',
        notYourUserId: '¿No eres tú? {userIdType}',
        userIdTypes: {
            'phone': 'número',
            'email': 'correo electrónico',
        },
        change: 'Cambiar',
        notReceivedCode: "¿No recibiste el código?",
        resendCode: 'Reenviar',
        in: 'en',
        verifyCode: 'VERIFICAR',
        logout: 'Cerrar sesión',
        orderNumberFieldTitle: 'Introduce el número de pedido para que podamos ayudarte',
        orderNumberFieldPlaceholder: 'Introduce el número de tu pedido Ej: #ES1234',
        zipcodeFieldTitle: 'Tu número de seguimiento',
        zipcodeFieldPlaceholder: 'Introduce tu número de seguimiento',
        emailFieldTitle: 'Correo electrónico',
        emailFieldPlaceholder: 'Introduce el correo electrónico',
    },
    orderList : {
        reorder: 'REORDENAR',
        getHelp: 'CONSIGUE AYUDA',
        startNewConversation: '+Nuevo mensaje',
        viewPreviousOrder:'VER TODOS LOS PEDIDOS',
        seeAll: 'Ver todo',
        viewMoreOrders: 'VER MÁS PEDIDOS',
        viewOrderStatus: 'VER ESTADO DEL PEDIDO',
        chatWithUs: 'HABLA CON NOSOTROS',
        issueWithPreviousOrder:'AYUDA CON PEDIDOS ANTERIORES' ,
        orderLabel: 'Pedido',
        help: 'AYUDA',
        lastOrder: 'Último pedido',
        selectRelevantItems: 'Seleccionar elementos relevantes',
        selectItemsErrorMsg: 'Por favor seleccione elementos para proceder',
        selectAll: 'Seleccionar todo',
        selectQuantity: 'Cuántos artículos',
        helpWithThisOrder: 'Ayuda con este pedido',
        yourOrders: 'Tus pedidos',
        view: 'VER',
        track: 'SEGUIMIENTO',
        addressTitle: 'Resumen del pedido',
        billingAddressTitle: 'DIRECCIÓN DE FACTURACIÓN',
        shippingAddressTitle: 'DIRECCIÓN DE ENVÍO',
        receiptTitle: 'artículos',
        itemTotal: 'total',
        taxes: 'Impuestos',
        discounts: 'Descuentos', 
        giftCard: 'Gift Card', 
        deliveryCharges: 'Gastos de envío',
        total: 'Total',
        loginToViewOrders: 'Cliente existente?',
        loginSuggestion: "Obtenga ayuda rápida y soporte de pedidos",
        trackingOrderLabel: 'Orden de seguimiento',
        shipmentDescription: "Regrese a esta página para obtener actualizaciones sobre el estado de su envío",
        free: "gratis",
        selectedItems: "Artículos seleccionados",
        items: "Artículos",
        "orderSearchPlaceholder": 'Filtrar por Pedido #',
        "noOrderFound": 'No hay pedidos que coincidan {orderId}',
    },
    chatListScreen: {
        header: 'Tus chats'
    },
    sentences: {
        "IN_A_DAY" : "Usualmente responderemos en el día.",
        "IN_FEW_MINUTES": "Usualmente responderemos en unos minutos.",
        "IN_FEW_HOURS": "Usualmente responderemos en unas horas.",
        "AS_SOON_AS_THEY_CAN": "Responderemos lo antes posible.",
        "BACK_ON": "De nuevo en",
        "BACK_IN": "De nuevo en",
        "HOURS": "horas",
        "MINUTES": 'minutos',
        provideBelowDetails: "Por favor proporcione la siguiente información:",
    },

    inputFields: {
        submitted: 'enviado'
    },

    inputPropDisplayNames: {
        "email": "Email",
        "phone": "Teléfono",
        "Phone": "Teléfono",
        "firstName": "Primero nombre",
        "lastName": "Apellido",
        "uid": "ID de usuario",
        "campaign": "Campaña UTM",
        "medium": "Medio UTM",
        "googleplus": "Google plus",
        "shippingPhone": "Teléfono",
        "source": "Fuente UTM",
        "lastOrderAt": "Fecha del último pedido",
        "firstOrderAt": "Fecha del primer pedido",
        "visits": "Sesiones",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Visto por última vez",
        "createdAt": "Visto por primera vez",
        "linkedin": "Linkedin",
        "instagram": "Instgram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "Correo electrónico para facturas",
        "billingPhone": "Teléfono de facturación",
        "shippingEmail": "Correo electrónico",
        "state": "Provincia",
        "city": "Ciudad",
        "country": "País",
        "deviceType": "Tipo de dispositivo",
        "browserName": "Tipo de navegador",
        "osName": "Nombre",
        "platform": "plataforma",
        "ltv": "CLV",
        "ordersCount": "Número de pedidos",
        "name": "Nombre",
        "RichpanelPredictedCLV": "CLV previsto",
        "RichpanelAliveProbability": "Probabilidad de comprar",
        "RichpanelNextOrderDate": "Fecha del próximo pedido",
        "RichpanelPredictedOrderCount": "Recuento de pedidos previsto",
        "aov": "AOV",
        "WebsiteURL":"URL de la web"
    },

    botMessages: {
        EXISITING_CUSTOMER: '¿Es usted un cliente existente?',
        YES_EXISITING_CUSTOMER: "Si, ya soy cliente",
        NO_EXISITING_CUSTOMER: "No, aún no soy cliente",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Dale al equipo una forma de contactarte.",
        "YOU_WILL_BE_NOTIFIED_EMAIL": "Se le notificará aquí y en su email ({email}) cuando respondamos.",
        "YOU_WILL_BE_NOTIFIED_NO_EMAIL": "Se le notificará aquí cuando respondamos.",
        "LEAVE_YOUR_MESSAGE": "Por favor deja tu mensaje.",
        TEAM_WILL_BE_BACK_IN:"Nuestro equipo volverá en {hours} horas",
        TEAM_WILL_BE_BACK_ON:"Nuestro equipo regresará el {availableAt}",
        FEW_MORE_DETAILS: "¡Gracias! Algunos detalles más nos ayudará a asignarle la persona adecuada:",
    },

    initialForm: {
        heading: 'Introduce tus datos para iniciar el chat.',
        startChat: 'Iniciar chat'
    },
    customerJourneyPreChatForm: {
        heading: 'Iniciar una conversación',
        startChat: 'Comenzar conversación',
        proceed: 'Continuar',
        canWeHelpWithAnythingElse: '¿Podemos ayudar con algo más?',
        yes: 'si',
        no: 'No',
        noThanks: "No, gracias",
        yesContactSupport: "Sí, Chatea con soporte",
        contactSupport: "Contacta al Soporte",
    },

    rating: {
        askedHeader: 'Valora tu conversación',
        successHeader: 'Has valorado esta conversación',
        thanksMessage: "Gracias por hacérnoslo saber.",
        placeholderForRatingFeedback: "Deja tu comentario"
    },

    placeholders: {
        emojiSearch: 'Buscar Emojis',
        typeAMessage: 'Escribe tu mensaje...',
        searchGifs: 'Buscar GIFs',
    },
    lastMessageText: {
        sentAGif: 'Envió un GIF',
        sharedFile: 'Compartió un archivo',
        askedForQualificationDetails: 'Solicitó más detalles sobre tu valoración',
        askedForRating: 'Valora la atención recibida',
        askedForFeedback: 'Deja tu comentario',
        sharedOrderSummary: "Resumen de pedido compartido",
    },
    greetingAnimation: {
        weAreOnline: 'Nosotras estamos en linea',
        askUsAnything: 'Pregúntenos cualquier cosa',
        chatWithUs: 'habla con nosotros'
    }
}